import $ from 'jquery';
var HIDING_ELEMENT = 'claims-item--hide'

$(document).ready(function () {
   
    if(document.querySelector('.claims')){ initClaimsForm(); }
});

function initClaimsForm(){
    document.querySelectorAll('.claims-selection input').forEach(function (elem) {
        elem.addEventListener('click', showQuestions);
    });

    document.querySelectorAll('.claims-item__label').forEach(function (elem) {
        elem.addEventListener('mouseenter', showHoverContent.bind(event, true));
        elem.addEventListener('mouseleave', showHoverContent.bind(event, false));
    });

    document.querySelector('#otherSelectionDog').addEventListener('change', (event) => onOtherSelectionChange(event));
    document.querySelector('#otherSelectionCat').addEventListener('change', (event) => onOtherSelectionChange(event));
    document.querySelector('#otherSelectionHorse').addEventListener('change', (event) => onOtherSelectionChange(event));
}

function onOtherSelectionChange(event) {

    var resetContentArray = document.querySelectorAll('.claims-selection  .js-dropdown-content, .claims-selection .claims-item__block' )

    resetContent(resetContentArray);

    var element = document.querySelectorAll("[data-question='" + event.target.value + "']");
    if (element.length > 0) {
        element[0].parentNode.classList.remove(HIDING_ELEMENT);

        element[0].closest(".claims-selection").classList.remove(HIDING_ELEMENT);

        if(document.querySelector('.js-secondary-selection input[name="claimPurpose"]:checked'))
        {
            document.querySelector('.js-secondary-selection input[name="claimPurpose"]:checked').checked = false
        }

        var allHoverAttribute = document.querySelectorAll('[data-hover-show]');

        allHoverAttribute.forEach(function (element){
            if (!element.classList.contains(HIDING_ELEMENT)) {
                element.classList.add(HIDING_ELEMENT)
            }
        });
        
        window.animalfriends.scroller.scrollToElem($(".js-content-section"));

    }    
}

function resetHoverStates(){

    var resetHoverStates = document.querySelectorAll('[data-hover-show]');

    resetHoverStates.forEach(function (element){
        if (!element.classList.contains(HIDING_ELEMENT)) {
            element.classList.add(HIDING_ELEMENT)
        }
    });
}

function showHoverContent(isMouseEnter, event) {
    
    var hoverAttribute = event.currentTarget.getAttribute('data-hover');

    resetHoverStates();
  
    if (hoverAttribute) {
        var toggleElement = document.querySelector('[data-hover-show="' + hoverAttribute + '"]')
        if (toggleElement) toggleElement.classList.toggle(HIDING_ELEMENT);
    }

    if(!isMouseEnter){
      var claimPurposeCheckedHover = document.querySelector('input[name="claimPurpose"]:checked')
      console.log(claimPurposeCheckedHover);

      if(claimPurposeCheckedHover){

        var toggleElement = document.querySelector('[data-hover-show="' + claimPurposeCheckedHover.parentNode.getAttribute('data-hover') + '"]')

        if (toggleElement) {

            resetHoverStates();
            toggleElement.classList.remove(HIDING_ELEMENT)
        }
      }
      else{
        var toggleElement = document.querySelector('[data-hover-show="' + hoverAttribute + '"]')
        if (toggleElement) toggleElement.classList.toggle(HIDING_ELEMENT);
      }
    }
}
function resetToggle(parentElement) {

    var resetElements = document.querySelectorAll('.claims-selection  input, .claims select')

    resetElements.forEach(function (element) {
        if (!element.parentNode.classList.contains(HIDING_ELEMENT) && element.closest('.js-primary-selection') <= 0 && !parentElement.classList.contains("js-secondary-selection")) {
            element.parentNode.classList.add(HIDING_ELEMENT);
        }
    })

    var resetTitles = document.querySelectorAll('.claims-selection')

    resetTitles.forEach(function (element) {

        if (!element.classList.contains(HIDING_ELEMENT) && element.getAttribute("data-order") > parentElement.getAttribute('data-order')) {

            element.classList.add(HIDING_ELEMENT);
        }
    })

    var resetContentArray = document.querySelectorAll('.claims-selection  .claims-item__block')
    resetContent(resetContentArray);
    
    resetHoverStates();
}

function resetContent(resettingArray){

    resettingArray.forEach(function (element) {
        if (!element.parentNode.classList.contains(HIDING_ELEMENT)) {
            element.parentNode.classList.add(HIDING_ELEMENT)
        }

    })
}

function showQuestions() {
    var parentElement = this.closest(".claims-selection");
    var listOfElement = this.getAttribute('data-answers');

    resetToggle(parentElement);

    if(listOfElement) {
        var array = listOfElement.split(",");

        array.forEach(function (answer) {
    
            var element = document.querySelectorAll("[data-question='" + answer + "']")

            if (element.length > 0) {
                element[0].parentNode.classList.remove(HIDING_ELEMENT);

                element[0].closest(".claims-selection").classList.remove(HIDING_ELEMENT);
            }

            var hoverElement = document.querySelectorAll("[data-hover-show='" + answer + "']")

            if (hoverElement.length > 0) {
                hoverElement[0].parentNode.classList.remove(HIDING_ELEMENT);

                hoverElement[0].classList.remove(HIDING_ELEMENT);
            }
        });
    }

    if (parentElement.classList.contains("js-secondary-selection")) {
        var productTypeValue = document.querySelector('input[name="productType"]:checked').value

        var claimPurposeValue = document.querySelector('input[name="claimPurpose"]:checked').value

        var element = document.querySelectorAll("[data-question='" + productTypeValue + claimPurposeValue + "']")

        if (element.length > 0) {
            element[0].parentNode.classList.remove(HIDING_ELEMENT);

            element[0].closest(".claims-selection").classList.remove(HIDING_ELEMENT);
        }

        window.animalfriends.scroller.scrollToElem($(".js-content-section"));
    }
    else if (parentElement.classList.contains("js-primary-selection") && document.querySelector('input[name="claimPurpose"]:checked') ){
        document.querySelector('input[name="claimPurpose"]:checked').checked = false;

    }
    else if(parentElement.classList.contains("js-primary-selection")){
        window.animalfriends.scroller.scrollToElem($(".js-secondary-selection"));
    }

    document.querySelector('#otherSelectionDog').value = "";
    document.querySelector('#otherSelectionCat').value = ""
    document.querySelector('#otherSelectionHorse').value = ""
}